import React from 'react';
import { Link } from 'react-router-dom';
import SeoLandingLayout from '../../components/SeoLandingLayout/SeoLandingLayout';
import {
  IA_CASOS,
  IA_HUB,
  IA_SERVICES,
  buildIaBreadcrumb,
} from '../../config/iaBrand';
import './CasosPage.css';

const CASOS = [
  {
    id: 'acufade',
    nombre: 'ACUFADE',
    sector: 'Dependencia y cuidadores familiares',
    problema:
      'Ordenar la intervención y el seguimiento de familias cuidadoras sin perder trazabilidad ni generar más carga administrativa.',
    modulo: 'Vulpin Social / Care — gestión de casos y seguimiento',
    web: 'https://www.acufade.org/',
  },
  {
    id: 'affa',
    nombre: 'AFFA (Alzheimer Fuerteventura)',
    sector: 'Familias de personas con Alzheimer y otras demencias',
    problema:
      'Unificar expedientes, plazas y equipos en un entorno donde el dato clínico-social exige control y confidencialidad.',
    modulo: 'Vulpin Social — residencial / atención y expediente',
    web: 'https://alzheimerfuerteventura.org/',
  },
  {
    id: 'mpdl',
    nombre: 'MPDL (Movimiento por la Paz)',
    sector: 'Acción social e intervención',
    problema:
      'Dar continuidad a proyectos y personas atendidas con información sensible, permisos claros y evidencia para justificación.',
    modulo: 'Vulpin Social — proyectos, casos y trazabilidad',
    web: 'https://www.mpdl.org/',
  },
];

const CasosPage = ({ darkMode, toggleDarkMode }) => (
  <SeoLandingLayout
    darkMode={darkMode}
    toggleDarkMode={toggleDarkMode}
    title="Casos de referencia: Vulpin y entidades del sector social | E-ASY"
    description="ACUFADE, AFFA (Alzheimer Fuerteventura) y MPDL: cómo entidades del tercer sector ordenan gestión y datos sensibles con Vulpin. Base para proyectos de IA privada."
    keywords="casos Vulpin, ACUFADE, AFFA Alzheimer Fuerteventura, MPDL, software tercer sector Canarias, IA privada sector social"
    canonical={IA_CASOS.url}
    h1="Casos de referencia en el sector social"
    lede="Entidades con las que trabajamos en gestión y datos sensibles. Son la base natural para proyectos de IA privada: el dato ya vive en Vulpin, no en una API genérica."
    ctaTo={IA_SERVICES.privada.path}
    ctaLabel="Ver IA privada / soberana"
    footerCtaTo="/contacto"
    footerCtaLabel="Hablar de un caso similar"
    breadcrumbJsonLd={buildIaBreadcrumb([
      { name: IA_HUB.label, url: IA_HUB.url },
      { name: IA_CASOS.label, url: IA_CASOS.url },
    ])}
    cobertura
  >
    <h2>Por qué estos casos importan para la IA</h2>
    <p>
      En dependencia, Alzheimer o intervención social el expediente no es un “dato de marketing”. Cualquier
      IA útil tiene que respetar RGPD, roles y el perímetro del cliente. Por eso enlazamos estos casos con{' '}
      <Link to={IA_SERVICES.privada.path}>{IA_SERVICES.privada.label}</Link>.
    </p>

    <div className="casos-grid">
      {CASOS.map((caso) => (
        <article key={caso.id} className="casos-card">
          <h3 className="casos-card-title">
            <a
              href={caso.web}
              target="_blank"
              rel="noopener noreferrer"
            >
              {caso.nombre}
            </a>
          </h3>
          <p className="casos-card-meta">
            <strong>Sector:</strong> {caso.sector}
          </p>
          <p>
            <strong>Problema resuelto:</strong> {caso.problema}
          </p>
          <p>
            <strong>Módulo Vulpin:</strong> {caso.modulo}
          </p>
        </article>
      ))}
    </div>

    <h2>Siguiente paso</h2>
    <p>
      Si tu entidad tiene un perfil parecido, podemos partir de{' '}
      <Link to="/vulpin">Vulpin Suite</Link> +{' '}
      <Link to={IA_SERVICES.privada.path}>IA on-premise</Link> o, si el foco es el marco legal de uso de
      IA por el personal, de{' '}
      <Link to={IA_SERVICES.cumplimiento.path}>{IA_SERVICES.cumplimiento.shortLabel}</Link>.
    </p>
    <p>
      Más contexto: <Link to="/tercer-sector">tercer sector</Link> ·{' '}
      <Link to="/erp-para-ong">software de gestión para ONG</Link> ·{' '}
      <Link to={IA_HUB.path}>{IA_HUB.label}</Link>.
    </p>
  </SeoLandingLayout>
);

export default CasosPage;
